  var popup_modal_click = document.getElementsByClassName("popup_modal_click");
  var collage_modal_main_container = document.getElementsByClassName("collage_modal_main_container");
  var collage_modal_close = document.getElementsByClassName("collage_modal_close");

  for(let i=0; i< popup_modal_click.length; i++){
    popup_modal_click[i].onclick = () => {
       collage_modal_main_container[i].classList.add("cm_visible");
    }
  }
  for(let i=0; i< collage_modal_close.length; i++){
    collage_modal_close[i].onclick = () => {
       collage_modal_main_container[i].classList.remove("cm_visible");
    }
  }